{
  "page": {
    "lookupFailed": "Couldn't open that digger's location. Please pick a digger from the list.",
    "entryUpdated": "An entry has been updated",
    "entryAdded": "A new entry has been added",
    "noDiggerAvailable": "No digger available",
    "noDiggerSelected": "No digger selected",
    "noDiggersInShift": "No diggers available in the selected date and shift.",
    "selectDiggerFirst": "Please select a digger first."
  },
  "columns": {
    "blastMasterId": "Blast Master Id",
    "pit": "Pit",
    "excavator": "Excavator",
    "materialType": "Material type",
    "addedBy": "Added by",
    "timeIn": "Time In",
    "timeOut": "Time Out"
  },
  "validation": {
    "startTimeRequired": "Start time must be selected"
  },
  "locationsTable": {
    "noBlastOptions": "No options for selected Pit Stage",
    "selectBlastMasterId": "Select Blast Master Id",
    "blastMasterRequired": "Blast Master Id must be selected",
    "patternUpdated": "Digging pattern updated successfully",
    "patternDeleted": "Digging pattern deleted successfully",
    "pitStageRequired": "Pit Stage must be selected",
    "locationAdded": "Location added successfully",
    "selected": "Selected",
    "empty": "No digging locations for the selected excavator.",
    "entity": "a digging location",
    "howToAdd": "Add a new digging location by selecting a <bold>pit</bold>, <bold>blastmaster</bold> and digging <bold>start time</bold> above."
  },
  "trucksTable": {
    "selectTruck": "Select Truck",
    "selectMaterial": "Select Material",
    "selectDestination": "Select Destination",
    "you": "You",
    "truckRequired": "Truck must be selected",
    "loadsBelowZero": "Loads can't be less than 0",
    "destinationRequired": "Destination must be selected",
    "materialTypeRequired": "Material type must be selected",
    "error": "Error: {{message}}",
    "loadAdded": "Truck load added successfully",
    "verifyAllOffline": "Verify All is not available offline",
    "nothingToVerify": "Nothing needed checking in this hour",
    "loadsVerified_one": "{{count}} truck load marked as checked",
    "loadsVerified_other": "{{count}} truck loads marked as checked",
    "loadsBelowZeroOnEdit": "Loads cannot less than 0",
    "loadUpdated": "Truck load updated successfully",
    "loadSaveFailed": "That load could not be saved. Check the value and try again.",
    "loadDeleted": "Truck load deleted successfully",
    "verificationSubject": "truck load",
    "loadMoved": "Loading record moved successfully",
    "title": "Production - <underline>{{blastMasterId}}</underline>",
    "hourNotStarted": "This hour hasn't started yet",
    "currentHour": "Current hour",
    "needsCheckingHint": "Show only loads the telemetry recorded that nobody has checked yet",
    "needsChecking": "Needs Checking",
    "verifyAll": "Verify All",
    "verifyAllConfirm": "Mark every unchecked truck load in this hour as checked?",
    "copyOffline": "Copy Previous Hour needs a connection; it is not available offline.",
    "nothingToCopy": "No truck loads to copy",
    "loadsCopied": "Truck loads copied successfully",
    "copyPreviousHour": "Copy Previous Hour",
    "move": "Move",
    "totalTruckLoads": "Total Truck Loads:",
    "hourTotal": "{{hour}}:",
    "noLoads": "No loads during selected hour."
  },
  "moveModal": {
    "title": "Move Loading Record",
    "from": "<bold>From: </bold>Blastmaster <bold>{{blastMasterId}}</bold> ({{pit}})",
    "to": "To: ",
    "optionLabel": "Blastmaster: {{blastMasterId}} - Pit: {{pit}}",
    "option": "Blastmaster: <bold>{{blastMasterId}}</bold> - Pit: <bold>{{pit}}</bold>",
    "noOtherLocations": "No other locations available",
    "selectBlastmaster": "Select blastmaster"
  },
  "summary": {
    "excavatorUpdated": "{{name}} has been updated",
    "patternUpdated": "Digging pattern has been updated",
    "excavatorAdded": "Digging data for {{name}} has been added",
    "patternAdded": "Digging data for a pattern has been added",
    "excavatorRemoved": "Digging data for {{name}} has been removed",
    "patternRemoved": "Digging data for a pattern has been removed",
    "totalLoads": "Total Loads:",
    "totalTonnes": "Total Tonnes:",
    "toBeConfirmed": "TBC",
    "noEntries": "No digging entries during selected shift.",
    "manageOnProduction": "You can manage digging entries on the <pageLink>Production<icon /></pageLink> page."
  },
  "operations": {
    "noNetwork": "No network connection",
    "ok": "OK",
    "onlyLatestOffline": "Only the latest shift can be completed while offline, because completing it creates the next shift on this device. Select the latest shift, or complete this one once the connection is back.",
    "tooEarlyHours": "The next shift does not start for another {{hours}} hours, so it cannot be created yet. Complete the shift within {{limit}} minutes of the next shift's start time.",
    "tooEarlyMinutes": "The next shift does not start for another {{minutes}} minutes, so it cannot be created yet. Complete the shift within {{limit}} minutes of the next shift's start time.",
    "completeOfflineTitle": "Complete shift offline?",
    "completeOfflineDay": "Completing the day shift of {{date}} while offline queues the completion on this device and creates the next shift here, so data entry can carry on. Engine hours, drilling patterns and validation are applied on the server when the connection returns.",
    "completeOfflineNight": "Completing the night shift of {{date}} while offline queues the completion on this device and creates the next shift here, so data entry can carry on. Engine hours, drilling patterns and validation are applied on the server when the connection returns.",
    "completeShift": "Complete Shift",
    "provisionalCreated": "A provisional shift has been created from cached data - {{machines}} machines and {{patterns}} digging locations carried over - so you can continue entering data for the next shift immediately. The shift will be completed fully when connectivity is restored: engine hours will be calculated, drilling patterns carried over, and validation run.",
    "queuedWithoutCache": "The shift completion has been queued, but there was no cached data for this shift on this device, so the new shift has no machines yet. It will be filled in as soon as the connection is back. To avoid this, open the Operations list while online before going offline.",
    "newShiftFailed": "The completion is queued and will be applied when connectivity is restored, but the new shift could not be created on this device ({{detail}}). Try Complete Shift again; closing and reopening the browser usually clears this.",
    "failedReadingQueue": "The shift could not be completed while reading the offline queue ({{detail}}). Nothing has been queued. Try again, and if it keeps happening close and reopen the browser.",
    "failedQueueing": "The shift could not be completed while queueing the completion ({{detail}}). Nothing has been queued. Try again, and if it keeps happening close and reopen the browser.",
    "shiftCompleted": "Shift completed successfully.",
    "multipleStoppage": "Multiple Stoppage"
  },
  "operationsTable": {
    "setAvailable": "Set available",
    "statuses": "Statuses",
    "filterByStatus": "Filter by Status",
    "machines": "Machines",
    "filterByMachine": "Filter by Machine Name",
    "updateFailed": "Error while updating the entry. Please refresh the page",
    "hoursSavedOffline": "Hours saved offline; they will sync when you reconnect",
    "hoursUpdated": "Hours updated successfully",
    "locationSavedOffline": "Location saved offline; it will sync when you reconnect",
    "locationUpdated": "Location updated successfully",
    "refreshFailed": "Error while refreshing the entry. Please refresh the page",
    "invalidStoppage": "Invalid stoppage selected, please try again",
    "statusUpdated": "Status updated",
    "toggleAvailable": "Toggle Available",
    "startEngineHours": "Start Engine Hours",
    "endEngineHours": "End Engine Hours",
    "fuel": "Fuel",
    "statusDescription": "Status Description",
    "availability": "Avail'",
    "totalHours": "Total Hours",
    "standby": "Standby",
    "notAvailable": "N/A",
    "nodDifference": "NOD Diff'",
    "hours": "{{value}}h",
    "utilisationOfAvailability": "UofA",
    "assetUtilisation": "Asset Util'",
    "selectLocation": "Select Location",
    "liveUpdatesInterrupted": "Live updates for this page have been interrupted. Please refresh the page",
    "machineUpdated": "{{name}} has been updated",
    "machinesUpdated": "{{names}} have been updated",
    "manyMachinesUpdated_one": "{{count}} machine has been updated",
    "manyMachinesUpdated_other": "{{count}} machines have been updated"
  },
  "nestedOperations": {
    "selectStoppageType": "Select Stoppage Type",
    "ongoingConfirm": "Adding a stoppage with empty time out will set it as ongoing and send a notification to all users.",
    "subtypeRequired": "Stoppage subtype must be selected",
    "timeOutBeforeTimeIn": "Time out must be later than time in",
    "stoppageAdded": "Stoppage added successfully",
    "stoppageDeleted": "Stoppage deleted successfully",
    "downtimeType": "Downtime Type",
    "unsynced": "Unsynced",
    "timeDown": "Time Down",
    "action": "Action"
  },
  "multipleStoppages": {
    "typeRequired": "Stoppage type must be selected",
    "plantsRequired": "Plants must be selected",
    "savedOffline_one": "{{count}} stoppage saved offline; it will sync when you reconnect",
    "savedOffline_other": "{{count}} stoppages saved offline; they will sync when you reconnect",
    "added": "Multiple stoppages added successfully",
    "addFailed": "Error adding multiple stoppages",
    "title": "Create Multiple Stoppages",
    "stoppageType": "Stoppage Type",
    "jobTypes": "Job Types",
    "selectMachines": "Select Machines",
    "deselectAll": "Deselect All",
    "selectAll": "Select All"
  }
}
